import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/site/SiteLayout";

// User-supplied lottery card artworks (placed in /public/lottery/*.png).
// Each PNG already contains the full green card + illustration + label —
// so the tile only needs to serve as an interactive container.
const GAMES = [
  { key: "wingo",  img: "/lottery/wingo.png",  name: "WINGO"      },
  { key: "k3",     img: "/lottery/k3.png",     name: "K3 LOTTERY" },
  { key: "5d",     img: "/lottery/5d.png",     name: "5D LOTTERY" },
  { key: "trxwin", img: "/lottery/trxwin.png", name: "TRX WINGO"  },
];

export default function LotteryHub() {
  return (
    <SiteLayout>
      <div className="min-h-[80vh] bg-gradient-to-b from-[#fff3f4] to-[#ffe4e6] py-6 sm:py-8 px-3 sm:px-4">
        <div className="max-w-6xl mx-auto">
          <div className="mb-5 sm:mb-6 text-center">
            <h1
              className="text-3xl sm:text-4xl font-black tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-rose-500 to-pink-500"
              data-testid="lottery-hub-title"
            >
              Lottery
            </h1>
            <p className="mt-2 text-slate-600 text-xs sm:text-sm">
              Instant-round lotteries — rounds every 30s to 10min
            </p>
          </div>

          <div
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4"
            data-testid="lottery-hub-grid"
          >
            {GAMES.map((g) => (
              <Link
                key={g.key}
                to={`/lottery/${g.key}`}
                aria-label={g.name}
                data-testid={`lottery-card-${g.key}`}
                className="group relative block rounded-[22px] overflow-hidden transition-transform duration-300 hover:-translate-y-1 shadow-[0_10px_28px_-10px_rgba(15,110,60,0.55)]"
              >
                <img
                  src={g.img}
                  alt={g.name}
                  loading="lazy"
                  draggable={false}
                  className="block w-full h-auto select-none"
                />
                {/* Hover ring */}
                <span
                  aria-hidden
                  className="absolute inset-0 rounded-[22px] pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{
                    boxShadow:
                      "inset 0 0 0 2px rgba(255,255,255,0.7), 0 0 30px rgba(255,255,255,0.35)",
                  }}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
